import { GenericRule, GenericRuleFactory } from '../../../../../../utils/genericValidator.util';
import { OfflineOrderProduct } from '../OfflineOrderProduct';
import { CreateOrderProductRulesParams } from './offlineOrderProduct.types';
import { ValidateAvailabilityLength } from './rules/ValidateAvailability.rule';
import { ValidateClosedGridRule } from './rules/ValidateClosedGrid.rule';
import { ValidateGridItemsThatShouldBeEmptyRule } from './rules/ValidateGridItemsThatShouldBeEmpty.rule';
import { ValidateGridLength } from './rules/ValidateGridLength.rule';
import { ValidatePriceInfoRule } from './rules/ValidatePriceInfo.rule';
import { ValidateProductColorPackIntegrityRule } from './rules/ValidateProductColorPackIntegrity.rule';
import { ValidateProductColorPackStockRule } from './rules/ValidateProductColorPackStock.rule';
import { ValidateStockOrderProductRule } from './rules/ValidateStock.rule';

export class OfflineOrderProductRulesFactory implements GenericRuleFactory<OfflineOrderProduct> {
  create({ useRulesTo }: CreateOrderProductRulesParams): GenericRule<OfflineOrderProduct>[] {
    switch (useRulesTo) {
      case 'CREATE':
        return this.createForCreate();
      case 'CREATE_WITH_PACK':
        return this.createForCreateWithPack();
      case 'CHANGE_GRID':
        return this.createForChangeGrid();
      case 'CHANGE_GRID_TO_ITEM':
        return this.createForChangeGridToItem();
      case 'CHANGE_PRICE_TABLE':
        return this.changePriceTable();
      case 'CHANGE_GRID_WITH_PACK':
        return this.createForChangeGridWithPack();
    }
  }

  private createForCreate(): GenericRule<OfflineOrderProduct>[] {
    return [
      new ValidateGridLength(),
      new ValidatePriceInfoRule(),
      new ValidateAvailabilityLength(),
      new ValidateStockOrderProductRule(),
      new ValidateProductColorPackStockRule(),
      new ValidateProductColorPackIntegrityRule(),
      new ValidateGridItemsThatShouldBeEmptyRule(),
    ];
  }

  private createForCreateWithPack(): GenericRule<OfflineOrderProduct>[] {
    return [new ValidateStockOrderProductRule(), ...this.createForCreate()];
  }

  private createForChangeGrid(): GenericRule<OfflineOrderProduct>[] {
    return [
      new ValidateStockOrderProductRule(),
      new ValidateProductColorPackStockRule(),
      new ValidateProductColorPackIntegrityRule(),
      new ValidateGridItemsThatShouldBeEmptyRule(),
    ];
  }

  private createForChangeGridToItem(): GenericRule<OfflineOrderProduct>[] {
    return [
      new ValidateClosedGridRule(),
      new ValidateStockOrderProductRule(),
      new ValidateProductColorPackStockRule(),
      new ValidateProductColorPackIntegrityRule(),
      new ValidateGridItemsThatShouldBeEmptyRule(),
    ];
  }

  private createForChangeGridWithPack(): GenericRule<OfflineOrderProduct>[] {
    return [new ValidateStockOrderProductRule(), ...this.createForChangeGrid()];
  }

  private changePriceTable(): GenericRule<OfflineOrderProduct>[] {
    return [new ValidatePriceInfoRule()];
  }
}
